<template>
  <div class="home">
    <Nav />
    <div class="top_line" />
    <div class="img_wrapper p1">
      <img src="https://summit-img.geekpark.net/r2020/p1_8.svg" />
      <a class="to_watch_live" href="https://space.bilibili.com/519227473/video" target="_blank">
        <img src="https://summit-img.geekpark.net/r2020/to_watch_live_2.svg" />
      </a>
    </div>
    <div class="img_wrapper p2">
      <img src="https://summit-img.geekpark.net/r2020/p2.svg" />
    </div>
    <div class="img_wrapper p3">
      <img src="https://summit-img.geekpark.net/r2020/p3_2.png" />
    </div>
    <div class="img_wrapper p4">
      <img src="https://summit-img.geekpark.net/r2020/p4_5.svg" />
    </div>
    <div class="img_wrapper pengge_wrapper">
      <img class="pengge_img" src="https://summit-img.geekpark.net/r2020/pengge_4.jpeg" />
      <a
        class="live_btn_wrapper"
        href="https://space.bilibili.com/519227473?from=search&seid=13418580983684229411"
        target="_blank"
      >
        <img class="live_btn" src="https://summit-img.geekpark.net/r2020/live_btn_2.svg" />
      </a>
      <div class="live_btn_text">直播间不定时互动抽奖</div>
    </div>

    <!-- 日程安排 -->
    <div class="img_wrapper date_wrapper data_title" id="datePlan">
      <img src="https://summit-img.geekpark.net/r2020/agende_2.svg" />
    </div>
    <div class="img_wrapper date_wrapper date_19">
      <img src="https://summit-img.geekpark.net/r2020/p_619_3.svg" />
    </div>
    <div class="guest_wrapper">
      <GuestItem
        v-for="g1_top_item in date19_top "
        :key="g1_top_item.name1"
        :type="g1_top_item.type"
        :title="g1_top_item.title"
        :show_time="g1_top_item.show_time"
        :rightArrow="g1_top_item.rightArrow"
        :slogan="g1_top_item.slogan"
        :themeColor="g1_top_item.themeColor"
        :avatar1="g1_top_item.avatar1"
        :identity1="g1_top_item.identity1"
        :name1="g1_top_item.name1"
        :id1="g1_top_item.id1"
        :achievement1="g1_top_item.achievement1"
        :sub_achievement1="g1_top_item.sub_achievement1"
        :avatar2="g1_top_item.avatar2"
        :identity2="g1_top_item.identity2"
        :name2="g1_top_item.name2"
        :id2="g1_top_item.id2"
        :achievement2="g1_top_item.achievement2"
        :sub_achievement2="g1_top_item.sub_achievement2"
        :vSrc="g1_top_item.vSrc"
      />
      <GuestItem
        v-for="g1_bottom_item in date19_bottom"
        :key="g1_bottom_item.name1"
        :type="g1_bottom_item.type"
        :title="g1_bottom_item.title"
        :show_time="g1_bottom_item.show_time"
        :rightArrow="g1_bottom_item.rightArrow"
        :slogan="g1_bottom_item.slogan"
        :themeColor="g1_bottom_item.themeColor"
        :avatar1="g1_bottom_item.avatar1"
        :identity1="g1_bottom_item.identity1"
        :name1="g1_bottom_item.name1"
        :id1="g1_bottom_item.id1"
        :achievement1="g1_bottom_item.achievement1"
        :sub_achievement1="g1_bottom_item.sub_achievement1"
        :avatar2="g1_bottom_item.avatar2"
        :identity2="g1_bottom_item.identity2"
        :name2="g1_bottom_item.name2"
        :id2="g1_bottom_item.id2"
        :achievement2="g1_bottom_item.achievement2"
        :sub_achievement2="g1_bottom_item.sub_achievement2"
        :vSrc="g1_bottom_item.vSrc"
      />
    </div>
    <div class="img_wrapper date_wrapper date_20">
      <img src="https://summit-img.geekpark.net/r2020/p_620_5.svg" />
    </div>
    <div class="guest_wrapper">
      <GuestItem
        v-for="g1_top_item in date20_one_top "
        :key="g1_top_item.name1"
        :type="g1_top_item.type"
        :title="g1_top_item.title"
        :show_time="g1_top_item.show_time"
        :rightArrow="g1_top_item.rightArrow"
        :slogan="g1_top_item.slogan"
        :themeColor="g1_top_item.themeColor"
        :avatar1="g1_top_item.avatar1"
        :identity1="g1_top_item.identity1"
        :name1="g1_top_item.name1"
        :id1="g1_top_item.id1"
        :achievement1="g1_top_item.achievement1"
        :sub_achievement1="g1_top_item.sub_achievement1"
        :avatar2="g1_top_item.avatar2"
        :identity2="g1_top_item.identity2"
        :name2="g1_top_item.name2"
        :id2="g1_top_item.id2"
        :achievement2="g1_top_item.achievement2"
        :sub_achievement2="g1_top_item.sub_achievement2"
        :vSrc="g1_top_item.vSrc"
      />
      <GuestItem
        v-for="g1_bottom_item in date20_one_bottom"
        :key="g1_bottom_item.name1"
        :type="g1_bottom_item.type"
        :title="g1_bottom_item.title"
        :show_time="g1_bottom_item.show_time"
        :rightArrow="g1_bottom_item.rightArrow"
        :slogan="g1_bottom_item.slogan"
        :themeColor="g1_bottom_item.themeColor"
        :avatar1="g1_bottom_item.avatar1"
        :identity1="g1_bottom_item.identity1"
        :name1="g1_bottom_item.name1"
        :id1="g1_bottom_item.id1"
        :achievement1="g1_bottom_item.achievement1"
        :sub_achievement1="g1_bottom_item.sub_achievement1"
        :avatar2="g1_bottom_item.avatar2"
        :identity2="g1_bottom_item.identity2"
        :name2="g1_bottom_item.name2"
        :id2="g1_bottom_item.id2"
        :achievement2="g1_bottom_item.achievement2"
        :sub_achievement2="g1_bottom_item.sub_achievement2"
        :vSrc="g1_bottom_item.vSrc"
      />
    </div>
    <div class="img_wrapper date_wrapper date_20">
      <img src="https://summit-img.geekpark.net/r2020/p_620_evening_5.svg" />
    </div>
    <div class="guest_wrapper">
      <GuestItem
        v-for="g1_top_item in date20_two_top "
        :key="g1_top_item.name1"
        :type="g1_top_item.type"
        :title="g1_top_item.title"
        :show_time="g1_top_item.show_time"
        :rightArrow="g1_top_item.rightArrow"
        :slogan="g1_top_item.slogan"
        :themeColor="g1_top_item.themeColor"
        :avatar1="g1_top_item.avatar1"
        :identity1="g1_top_item.identity1"
        :name1="g1_top_item.name1"
        :id1="g1_top_item.id1"
        :achievement1="g1_top_item.achievement1"
        :sub_achievement1="g1_top_item.sub_achievement1"
        :avatar2="g1_top_item.avatar2"
        :identity2="g1_top_item.identity2"
        :name2="g1_top_item.name2"
        :id2="g1_top_item.id2"
        :achievement2="g1_top_item.achievement2"
        :sub_achievement2="g1_top_item.sub_achievement2"
        :vSrc="g1_top_item.vSrc"
      />
      <GuestItem
        v-for="g1_bottom_item in date20_two_bottom"
        :key="g1_bottom_item.name1"
        :type="g1_bottom_item.type"
        :title="g1_bottom_item.title"
        :show_time="g1_bottom_item.show_time"
        :rightArrow="g1_bottom_item.rightArrow"
        :slogan="g1_bottom_item.slogan"
        :themeColor="g1_bottom_item.themeColor"
        :avatar1="g1_bottom_item.avatar1"
        :identity1="g1_bottom_item.identity1"
        :name1="g1_bottom_item.name1"
        :id1="g1_bottom_item.id1"
        :achievement1="g1_bottom_item.achievement1"
        :sub_achievement1="g1_bottom_item.sub_achievement1"
        :avatar2="g1_bottom_item.avatar2"
        :identity2="g1_bottom_item.identity2"
        :name2="g1_bottom_item.name2"
        :id2="g1_bottom_item.id2"
        :achievement2="g1_bottom_item.achievement2"
        :sub_achievement2="g1_bottom_item.sub_achievement2"
        :vSrc="g1_bottom_item.vSrc"
      />
    </div>
    <div class="img_wrapper date_wrapper date_21">
      <img src="https://summit-img.geekpark.net/r2020/p_621_4.svg" />
    </div>
    <div class="guest_wrapper">
      <GuestItem
        v-for="g1_top_item in date21_one_top "
        :key="g1_top_item.name1"
        :type="g1_top_item.type"
        :title="g1_top_item.title"
        :show_time="g1_top_item.show_time"
        :rightArrow="g1_top_item.rightArrow"
        :slogan="g1_top_item.slogan"
        :themeColor="g1_top_item.themeColor"
        :avatar1="g1_top_item.avatar1"
        :identity1="g1_top_item.identity1"
        :name1="g1_top_item.name1"
        :id1="g1_top_item.id1"
        :achievement1="g1_top_item.achievement1"
        :sub_achievement1="g1_top_item.sub_achievement1"
        :avatar2="g1_top_item.avatar2"
        :identity2="g1_top_item.identity2"
        :name2="g1_top_item.name2"
        :id2="g1_top_item.id2"
        :achievement2="g1_top_item.achievement2"
        :sub_achievement2="g1_top_item.sub_achievement2"
        :vSrc="g1_top_item.vSrc"
      />
      <GuestItem
        v-for="g1_bottom_item in date21_one_bottom"
        :key="g1_bottom_item.name1"
        :type="g1_bottom_item.type"
        :title="g1_bottom_item.title"
        :show_time="g1_bottom_item.show_time"
        :rightArrow="g1_bottom_item.rightArrow"
        :slogan="g1_bottom_item.slogan"
        :themeColor="g1_bottom_item.themeColor"
        :avatar1="g1_bottom_item.avatar1"
        :identity1="g1_bottom_item.identity1"
        :name1="g1_bottom_item.name1"
        :id1="g1_bottom_item.id1"
        :achievement1="g1_bottom_item.achievement1"
        :sub_achievement1="g1_bottom_item.sub_achievement1"
        :avatar2="g1_bottom_item.avatar2"
        :identity2="g1_bottom_item.identity2"
        :name2="g1_bottom_item.name2"
        :id2="g1_bottom_item.id2"
        :achievement2="g1_bottom_item.achievement2"
        :sub_achievement2="g1_bottom_item.sub_achievement2"
        :vSrc="g1_bottom_item.vSrc"
      />
    </div>
    <div class="img_wrapper date_wrapper date_21">
      <img src="https://summit-img.geekpark.net/r2020/p_621_evening_4.svg" />
    </div>

    <div class="guest_wrapper">
      <GuestItem
        v-for="g1_top_item in date21_two_top "
        :key="g1_top_item.name1"
        :type="g1_top_item.type"
        :title="g1_top_item.title"
        :show_time="g1_top_item.show_time"
        :rightArrow="g1_top_item.rightArrow"
        :slogan="g1_top_item.slogan"
        :themeColor="g1_top_item.themeColor"
        :avatar1="g1_top_item.avatar1"
        :identity1="g1_top_item.identity1"
        :name1="g1_top_item.name1"
        :id1="g1_top_item.id1"
        :achievement1="g1_top_item.achievement1"
        :sub_achievement1="g1_top_item.sub_achievement1"
        :avatar2="g1_top_item.avatar2"
        :identity2="g1_top_item.identity2"
        :name2="g1_top_item.name2"
        :id2="g1_top_item.id2"
        :achievement2="g1_top_item.achievement2"
        :sub_achievement2="g1_top_item.sub_achievement2"
        :vSrc="g1_top_item.vSrc"
      />
      <GuestItem
        v-for="g1_bottom_item in date21_two_bottom"
        :key="g1_bottom_item.name1"
        :type="g1_bottom_item.type"
        :title="g1_bottom_item.title"
        :show_time="g1_bottom_item.show_time"
        :rightArrow="g1_bottom_item.rightArrow"
        :slogan="g1_bottom_item.slogan"
        :themeColor="g1_bottom_item.themeColor"
        :avatar1="g1_bottom_item.avatar1"
        :identity1="g1_bottom_item.identity1"
        :name1="g1_bottom_item.name1"
        :id1="g1_bottom_item.id1"
        :achievement1="g1_bottom_item.achievement1"
        :sub_achievement1="g1_bottom_item.sub_achievement1"
        :avatar2="g1_bottom_item.avatar2"
        :identity2="g1_bottom_item.identity2"
        :name2="g1_bottom_item.name2"
        :id2="g1_bottom_item.id2"
        :achievement2="g1_bottom_item.achievement2"
        :sub_achievement2="g1_bottom_item.sub_achievement2"
        :vSrc="g1_bottom_item.vSrc"
      />
    </div>
    <!-- 尾页 -->
    <div class="img_wrapper p5">
      <img class="geek_park_go" src="https://summit-img.geekpark.net/r2020/geek_park_go.svg" />
      <img src="https://summit-img.geekpark.net/r2020/p5_3.svg" />
    </div>
    <!-- 往届回顾 -->
    <div class="img_wrapper p6" id="last_years">
      <img src="https://summit-img.geekpark.net/r2020/p6_3.svg" />
      <div class="last_list_wrapper" id="contcat">
        <a href="http://r2019.geekpark.net/" target="_blank">
          <img src="https://summit-img.geekpark.net/r2020/year_2019.svg" />
        </a>
        <a href="http://r2019.geekpark.net/" target="_blank">
          <img src="https://summit-img.geekpark.net/r2020/year_2018.svg" />
        </a>
        <a href="http://r2019.geekpark.net/" target="_blank">
          <img src="https://summit-img.geekpark.net/r2020/year_2017.svg" />
        </a>
        <a href="http://r2019.geekpark.net/" target="_blank">
          <img src="https://summit-img.geekpark.net/r2020/year_2016.svg" />
        </a>
      </div>
    </div>

    <div class="video_wrapper" id="geekpark_video_iframe_wrapper" style="display:none;">
      <div class="innner_yellow_border" />
      <div class="innner_black_bg" />
      <img
        alt="关闭视频"
        class="close_video_btn"
        src="https://summit-img.geekpark.net/r2020/close_video_btn.svg"
        @click="closeVideo"
      />
      <div class="link_line_close"></div>
      <iframe
        id="geekpark_video_iframe"
        style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;z-index: 99;"
        src="//player.bilibili.com/player.html?aid=371093773&bvid=BV1zZ4y1H7tZ&cid=203266270&page=1&high_quality=1&danmaku=0"
        frameborder="no"
        scrolling="no"
      ></iframe>
    </div>
  </div>
</template>

<script>
import GuestItem from "@/components/mobile/GuestItem.vue";
import Nav from "@/components/mobile/Nav.vue";

export default {
  name: "HomeMible",
  components: { GuestItem, Nav },
  computed: {
    date19_top() {
      return this.$store.state.guests.date19_top;
    },
    date19_bottom() {
      return this.$store.state.guests.date19_bottom;
    },
    date20_one_top() {
      return this.$store.state.guests.date20_one_top;
    },
    date20_one_bottom() {
      return this.$store.state.guests.date20_one_bottom;
    },
    date20_two_top() {
      return this.$store.state.guests.date20_two_top;
    },
    date20_two_bottom() {
      return this.$store.state.guests.date20_two_bottom;
    },
    date21_one_top() {
      return this.$store.state.guests.date21_one_top;
    },
    date21_one_bottom() {
      return this.$store.state.guests.date21_one_bottom;
    },
    date21_two_top() {
      return this.$store.state.guests.date21_two_top;
    },
    date21_two_bottom() {
      return this.$store.state.guests.date21_two_bottom;
    },
  },
  methods: {
    closeVideo() {
      const vIframeWrapper = document.getElementById(
        "geekpark_video_iframe_wrapper"
      );
      const vIframe = document.getElementById("geekpark_video_iframe");
      vIframeWrapper.style.display = "none";
      vIframe.src = "";
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  background: #fff;
  .top_line {
    border-top: 1px solid #ccc;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
  .p1 {
    position: relative;
    .to_watch_live {
      position: absolute;
      top: 85vw;
      left: 7vw;
      img {
        width: 64vw;
        height: auto;
      }
    }
  }
  .img_wrapper {
    font-size: 0;
    img {
      width: 100%;
      height: auto;
    }
  }
  .pengge_wrapper {
    position: relative;
    .live_btn_wrapper {
      position: absolute;
      top: 66vw;
      left: 24vw;
      .live_btn {
        width: 56vw;
        height: auto;
      }
    }
    .live_btn_text {
      position: absolute;
      top: 79vw;
      left: 33vw;
      font-size: 3.6vw;
      font-weight: bold;
    }
    .pengge_img {
      margin-top: 30px;
    }
  }
  .p2 {
    padding: 40px 0 60px 20px;
  }
  .date_wrapper {
    margin-top: 40px;
  }
  .p5 {
    position: relative;
    margin-top: 90px;
    .geek_park_go {
      position: absolute;
      top: -52px;
      left: 0;
      z-index: 2;
    }
  }
  .guest_wrapper {
    padding: 10px 10px 0px 10px;
  }
  .p6 {
    position: relative;
    margin-top: 50px;
    .last_list_wrapper {
      position: absolute;
      width: 100%;
      top: 32vw;
      left: 0;
      padding: 0px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      a {
        width: 44%;
        display: block;
        &:nth-child(1),
        &:nth-child(2) {
          margin-bottom: 20px;
        }
      }
    }
  }

  .video_wrapper {
    position: fixed;
    width: 90vw;
    height: 51vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #000;
    z-index: 9;
    .close_video_btn {
      position: absolute;
      top: -48px;
      left: 50%;
      transform: translateX(-50%);
      height: 26px;
      width: auto;
      z-index: 98;
      &:hover {
        cursor: pointer;
      }
    }
    .link_line_close{
      position: absolute;
      top: -32px;
      left: 50%;
      height: 60px;
      width: 4px;
      border-left: 1px solid #000;
    }
    .innner_black_bg {
      background: #000;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
    .innner_yellow_border {
      content: " ";
      display: block;
      width: 100%;
      height: 100%;
      background: #faf04e;
      border: 1px solid #000;
      position: absolute;
      bottom: -0.5vw;
      right: -0.5vw;
    }
  }
}
</style>